"use client";

import { Check } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const strategyItems = ["Halal Certified Meats", "Punjabi Spice Profiles", "American Smash Burgers", "Signature Karahi Bowls", "Fusion Street Tacos", "Hand-Crafted Masala Fries"];
export default function VCisoStrategy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}